<template>
  <!-- 设备管理-->
 <div class="cont">
    <div class="map" >
      <div id="map"></div>
      <div class="detail" >
        <div class="searchBox" ref="searchBox">
          <el-form :inline="true"  :model="searchFrom" ref="searchFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="90px" size="mini">
            <span class="miaoshu">注：只能查询24小时之内的历史轨迹</span>
          <el-form-item label="时间区间:" prop="time">
              <el-date-picker
                 :picker-options="pickerOptions"
                v-model="searchFrom.time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['12:00:00', '12:00:00']"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="车牌号码:" prop="vchNo">
                <el-input  placeholder="" v-model="searchFrom.vchNo"></el-input>
              </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="clearFn">重置</el-button>
          </el-form-item>
        </el-form>
        </div>
         <div class="box1">
            <div class="item"><span class="name">行驶时间：</span><span>{{runTime}}</span></div>
            <div class="item"><span class="name">行驶里程：</span><span>{{mileage}}</span></div>
         </div>
         <div class="box2">
            <div class="name item" @click="reduceSudu" style="cursor: pointer;">减速播放</div>
            <div class="btn1 item" @click="pauseAnimation"> <i class="fa fa-pause-circle"></i></div>
            <div class="btn1 item"  @click="startAnimation"> <i class="fa fa-play-circle" style="color: #e62323"></i></div>
            <div class="btn1 item" @click="clearFn"> <i class="fa fa-stop-circle"></i></div>
            <div class="name item" @click="addSudu" style="cursor: pointer;">加速播放</div>
         </div>
      </div>
    </div>
    <div class="bottom table">
         <el-table :data="gpsInfos"  ref="vehList" height="100%" v-loading="loading" border  >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
       <el-table-column property="" label="车牌号" >
          <template>
            {{searchFrom.vchNo}}
          </template>
        </el-table-column>
        <!-- :formatter="dateFormat" -->
        <el-table-column prop="gPSDate" width="170"   label="上报时间"></el-table-column>
        <el-table-column prop="addressGrid"  min-width="260" :show-overflow-tooltip="true" label="当前位置"></el-table-column>
        <el-table-column  prop="speed" width="140" label="当前速度(KM/H)" ></el-table-column>
         <el-table-column  prop="direction" width="140" :formatter="fx" label="当前方向" ></el-table-column>
        <el-table-column  prop="encryptLongitude" width="120" :show-overflow-tooltip="true" label="经度" ></el-table-column>
        <el-table-column  prop="encryptDimension" width="120" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
      </el-table>
    </div>
 </div>
</template>

<script>
import AMap from 'AMap'
import { vhcHisList, zjVhcHisList } from '@/api/vehMonitor'
export default {
  data () {
    return {
      searchFrom: {
        serverName: '中物网络货运'
      },
      loading: false,
      rules: {
        time: [
          { required: true, message: '请选择时间区间', trigger: 'blur' }
        ],
        vchNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ]

      },
      marker: null,
      map: null,
      polyline: null,
      isPlay: false,
      lineArr: [],
      runTime: 0,
      mileage: 0.00,
      gpsInfos: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      }

    }
  },
  created () {

  },
  mounted () {
    this.initMap()
  },
  methods: {
    searchFn () {
      let that = this
      this.$refs.searchFrom.validate((valid) => {
        if (valid) {
          this.searchFrom.startTime = this.searchFrom.time[0]
          this.searchFrom.endTime = this.searchFrom.time[1]
          let time = new Date(that.searchFrom.time[1]).getTime() - new Date(that.searchFrom.time[0]).getTime()
          if (time > 3600 * 1000 * 24) {
            this.$alert('请选择24小时之内的时间', '系统提示')
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.loading = true
            this.searchFrom.serverName = '中物网络货运'
            vhcHisList(this.searchFrom).then(res => {
              loading.close()
              if (res) {
                this.lineArr = res.list
                this.polylineFn()
                if (res.flag == 'vms') {
                  this.loading = false
                  this.gpsInfos = res.gpsInfos ? res.gpsInfos : []
                  this.runTime = res.runTime
                  if (this.gpsInfos.length > 0) {
                    this.mileage = res.gpsInfos[res.gpsInfos.length - 1].mileage
                  }
                } else {
                  zjVhcHisList(this.searchFrom).then(res1 => {
                    this.gpsInfos = res1.gpsInfos
                    if (res1.gpsInfos.length > 0) {
                      this.mileage = res1.gpsInfos[res1.gpsInfos.length - 1].mileage
                    }
                    this.runTime = res1.runTime
                    this.loading = false
                  })
                }
              } else {
                this.$alert('暂无历史轨迹', '系统提示')
              }
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    startAnimation () {
      if (this.isPlay) {
        this.marker.resumeMove()
      } else {
        this.marker.moveAlong(this.lineArr, 800)
      }
    },
    pauseAnimation () {
      this.marker.pauseMove()
      this.isPlay = true
    },
    addSudu () {
      this.marker.moveAlong(this.lineArr, 1500)
    },
    reduceSudu () {
      this.marker.moveAlong(this.lineArr, 500)
    },
    clearFn () {
      this.map.clearMap()
      this.searchFrom = { time: null }
      this.gpsInfos = []
      this.runTime = 0
      this.mileage = 0
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    },
    polylineFn () {
      if (this.marker) {
        this.map.clearMap()
      }
      this.isPlay = false
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),

        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.map.setFitView()
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {

    },
    fx: function (row, column, cellValue) {
      // 北方向
      if (cellValue >= 0 && cellValue <= 22 || cellValue >= 338 && cellValue <= 360) {
        return '北'
      }
      // 东北方向
      if (cellValue >= 23 && cellValue <= 67) {
        return '东北'
      }
      // 东方向
      if (cellValue >= 68 && cellValue <= 112) {
        return '东'
      }
      // 东南方向
      if (cellValue >= 113 && cellValue <= 157) {
        return '东南'
      }
      // 南方向
      if (cellValue >= 158 && cellValue <= 202) {
        return '南'
      }
      // 西南方向
      if (cellValue >= 203 && cellValue <= 247) {
        return '西南'
      }
      // 西方向
      if (cellValue >= 248 && cellValue <= 292) {
        return '西'
      }
      // 西北方向
      if (cellValue >= 293 && cellValue <= 337) {
        return '西北'
      }
    }
  }
}
</script>
<style scoped lang='less'>
.cont{
  height:100%
}
.map{
  width: 100%;
  margin-top: -12px;
  height:70%;
  position: relative;
  background: #ddd;
}
.bottom{
  height: 30%;
}
#map{
  width: 100%;
  height: 100%;
}
.detail{
  position: absolute;
  right: 0px;
  top: 0;
  background: #fff;
  width: 450px;
  border-radius: 0px 0px 0px 10px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  padding:16px 0px;
  font-size: 12px;
   .box1{
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    padding-left: 20px;
    padding-top: 10px;
    border-bottom: 1px  solid #ddd;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0c46a2;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  .box2{
    display: flex;
    justify-content: center;
    margin-top: 10px;
    align-items: center;
    .item{
      margin: 0 10px;
    }
    .name{
      color:  #0c46a2;
      flex-shrink:0;
    }
    .btn1{
      font-size: 34px;
    }
  }
}
.miaoshu{
  padding-left: 90px;
    margin-bottom: 2px;
    display: inline-block;
    color: #848484;
}
/deep/ .el-date-editor--datetimerange.el-input__inner{
      width: 340px;
}

</style>
